interface ReadOnlyRatingProps {
  rating: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const calculateColor = (rating: number) => {
  const ratio = rating / 10;
  const redIntensity = Math.round(255 * (1 - ratio) * 2);
  const greenIntensity = Math.round(255 * Math.min(ratio * 2, 1));
  const blueIntensity = Math.round(255 * Math.max(0, (ratio - 0.5) * 2));
  return `rgb(${redIntensity}, ${greenIntensity}, ${blueIntensity})`;
};

const sizeClasses = {
  sm: 'text-sm px-2 py-0.5',
  md: 'text-base px-2.5 py-0.5',
  lg: 'text-lg px-3 py-1'
} as const;

export const ReadOnlyRating = ({ rating, className = '', size = 'lg' }: ReadOnlyRatingProps) => {
  const integerPart = Math.floor(rating);
  const decimalPart = rating % 1;

  return (
    <div
      className={`font-bold rounded-md ${sizeClasses[size]} ${className}`}
      style={{
        backgroundColor: calculateColor(rating),
        color: '#333'
      }}
    >
      {integerPart}
      {decimalPart > 0 && (
        <span className="text-[0.8em]">
          {decimalPart.toFixed(2).substring(1)}
        </span>
      )}
    </div>
  );
};